import { Button, Flex, TabPanel, useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { formatDate } from "utils";
import {
  AICheckOutput,
  ActivityDetailsSources,
  ActivityDetailsUpdateAnswer,
} from "./components/AnswerActivityOneEvent";
import issbAPI from "api/issb/issb";
import { LabelText, ValueText } from "components/text/TextTypes";

/**
 * See https://www.figma.com/design/uDql1qJTNBIvGnFDsOpWV4/ESG360-AIR?node-id=3481-50278&t=FJT8f8XlaR10eM6g-1
 */
export default function AIDraftTab({
  questionId,
  canSave,
  activity,
  applyActivity,
  isActive,
  setReadFlag: setReadFlagLocal,
  questionData,
  allQuestionDataByRef,
  tags,
}) {
  //   console.log("AIDraftTab", activity?.id);
  const toast = useToast();
  const handleApply = () => {
    applyActivity(activity);
    toast({
      title: "AI answer applied",
      description: "The AI answer has been applied to the question.",
      status: "success",
    });
  };
  // set the read flag to true
  useEffect(() => {
    if (isActive && !activity?.readFlag) {
      setReadFlagLocal(true);
      issbAPI.updateActivitySetReadFlag(activity);
    }
  }, [isActive, activity, setReadFlagLocal]);

  return (
    <TabPanel>
      <Flex direction="column" gap={2}>
        {/* User and Date - copy-pasta from AnswerActivityOneEvent */}
        <div>
          {" "}
          {/* NB: use div wrappers to manage the spacing: Label&Text close, then flex gaps between*/}
          <LabelText color="headingGrey" fontSize="body.xs">
            Date
          </LabelText>
          <ValueText>{formatDate(activity?.date, true, false)}</ValueText>
        </div>
        {/* TODO - lookup user name on-demand  activity.requestedBy && (
				<div>
					<LabelText color="headingGrey" fontSize="body.xs">
						Requested by
					</LabelText>
					<ValueText>{activity.requestedBy}</ValueText>
				</div>
			)*/}

        <ActivityDetailsUpdateAnswer
          activity={activity}
          questionData={questionData}
          showOldAnswer={false}
          useEditorAsViewer={true}
          allQuestionDataByRef={allQuestionDataByRef}
          tags={tags}
        />

        <AICheckOutput activity={activity} />

        <ActivityDetailsSources activity={activity} questionData={questionData} />

        <Button variant="primary" onClick={handleApply} disabled={!canSave}>
          {activity.draft ? "Apply Answer" : "Reapply Answer"}
        </Button>
      </Flex>
    </TabPanel>
  );
}
